import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useEffect, useRef } from "react";
import { useProfile } from "../../context/ProfileContext";
import api from "../../utils/api";
import { apiUrls } from "../../utils/urls";
import { formatPhoneNumber } from "../../utils/formatting";

export default function VerifyPhoneNumberDialog({ ...props }) {
  const linkSentDate = useRef(null);
  const { profile } = useProfile();

  const sendText = async () => {
    await api.post(apiUrls.users.phoneVerificationLink(), {
      redirect_url: window.location.toString(),
    });
  };
  useEffect(() => {
    const resendLink =
      linkSentDate.current == null ||
      (new Date() - linkSentDate.current) / 1000 >= 60;

    if (resendLink && props.open) {
      linkSentDate.current = new Date();
      sendText();
    }
  }, [props]);

  return (
    <Dialog {...props}>
      <DialogTitle>Verification Text Sent!</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          An phone number verification link has been texted to you at{" "}
          <span style={{ fontWeight: "bold" }}>
            {formatPhoneNumber(profile?.phone_number)}
          </span>
          .
        </Typography>
        <br />
        <Typography variant="body1">
          Once you have visited that link, refresh your profile for the changes
          to take effect!
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button type="submit" onClick={props.onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
